module.exports = __webpack_public_path__ + "img/Stimmung.b5eb2fdb.svg";